import { spaUserRoleIds } from '../pages/Users/components/grid/config/columns';

export const filterCriteria = (filterForm, data, page) => {
    const filterCriteria = {};

    // Check if the page is 'products' and set the filter criteria accordingly
    if (page === 'readyProducts') {
        filterCriteria.loadStatus = 'READY';
    }

    if (page === 'products') {
        // Convert productId string to number for backend compatibility
        filterCriteria.productId = filterForm.productId ? parseInt(filterForm.productId, 10) : undefined;
        filterCriteria.productTitle = filterForm.productTitle;
        filterCriteria.classFilter = filterForm.classFilter ? filterForm.classFilter.value : '';
        filterCriteria.loadStatus = filterForm.loadStatus ? filterForm.loadStatus.value : '';
        filterCriteria.legalStatusId = filterForm.legalStatusId
            ? filterForm.legalStatusId.value
            : '';
        filterCriteria.startYear = filterForm.startYear;
        filterCriteria.endYear = filterForm.endYear;
        filterCriteria.foxFinancialTitleId = data.foxFinancialTitleId;
    }

    if (page === 'jobs') {
        filterCriteria.jobIds = filterForm.jobId;
        filterCriteria.spaJobType = filterForm.jobType ? filterForm.jobType?.id : '';
        filterCriteria.dealIdFilter = filterForm.dealId;
        filterCriteria.spaJobStatus = filterForm.jobStatus ? filterForm.jobStatus?.id : '';
        filterCriteria.startDate = filterForm.startDate
        filterCriteria.endDate = filterForm.endDate
    }

    if (page === 'jobTasks') {
        filterCriteria.jobId = filterForm.jobId;
        filterCriteria.spaJobStatus = filterForm.taskStatus ? filterForm.taskStatus?.id : '';
    }

    if (page === 'dateMath') {
        filterCriteria.jobIds = filterForm.jobId;
        filterCriteria.spaJobStatus = filterForm.jobStatus ? filterForm.jobStatus?.id : '';
        filterCriteria.spaJobType = filterForm.jobType ? filterForm.jobType?.id : '';
    }

    if (page === 'dateMathCalculations') {
        filterCriteria.jobId = filterForm.jobId;
        filterCriteria.loadStatus = filterForm.loadStatus ? filterForm.loadStatus?.id : '';
    }

    // Check if the page is 'rights' and set the filter criteria accordingly
    if (page === 'rights') {
        filterCriteria.rightId = filterForm.rightId;
        filterCriteria.q = filterForm.rightTitle;
        filterCriteria.template = filterForm.rightTemplate;
        filterCriteria.dealId = filterForm.dealId;
        filterCriteria.catalogId = filterForm.catalogId;
        // Build dealCatalog array from checkbox values (hasDeal, hasCatalog)
        const dealCatalogValues = [];
        if (filterForm.hasDeal) dealCatalogValues.push('deal');
        if (filterForm.hasCatalog) dealCatalogValues.push('catalog');
        filterCriteria.dealCatalog = dealCatalogValues;
        filterCriteria.showFailedAssociations = filterForm.showFailedAssociations;
    }

    if (page === 'productUpdates') {
        filterCriteria.fromUpdatedDate = filterForm.fromDate;
        filterCriteria.toUpdatedDate = filterForm.toDate;
        filterCriteria.title = filterForm.title;
        // Convert ID strings to numbers for backend compatibility
        filterCriteria.groupId = filterForm.groupId ? parseInt(filterForm.groupId, 10) : undefined;
        filterCriteria.productId = filterForm.productId ? parseInt(filterForm.productId, 10) : undefined;
        filterCriteria.hideIgnored = filterForm.hideIgnored;
        filterCriteria.hideCompleted = filterForm.hideCompleted;
        filterCriteria.hideUpdates = filterForm.hideUpdates;
        filterCriteria.hideNA = filterForm.hideNA;
        filterCriteria.espnTitle = data;
    }

    if (page === 'dealVersions') {
        filterCriteria.dealId = filterForm.dealId;
        filterCriteria.dealTitle = filterForm.dealTitle;
        filterCriteria.showSubversions = filterForm.showSubversions;
    }

    if (page === 'pmxDeliveries') {
        filterCriteria.skuId = filterForm?.skuId;
        filterCriteria.action = filterForm?.action?.value;
        filterCriteria.status = filterForm?.status?.value;
    }

    if (page === 'users') {
        filterCriteria.fullName = filterForm.name;
        filterCriteria.emailAddress = filterForm.email;
        if (filterForm.role) {
            const r = Array.isArray(filterForm.role)
                ? filterForm.role[0]
                : filterForm.role;
            if (r && r.value != null && r.value !== '') {
                filterCriteria.roleIds = String(r.value);
            }
        }
    }

    if (page === 'dealDROChanges') {
        filterCriteria.timestampStart = filterForm.timestampStart
        filterCriteria.timestampEnd = filterForm.timestampEnd
    }    

    // Filter out any properties with empty values from the filterCriteria object
    return Object.fromEntries(
        Object.entries(filterCriteria).filter(
            ([_, value]) => value !== undefined && value !== null && value !== '',
        ),
    );
};
